module.exports = "/dist/f4e8dc5995b7b64c394f30df27a83612.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-900.woff2
// module id = 165
// module chunks = 0